var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.353,
    height: 77,
    viewBox: "0 0 80.353 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34010",
    "data-name": "Group 34010",
    transform: "translate(67.749 -38.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72231",
    "data-name": "Path 72231",
    d: "M-56.674,112.872H1.464a8.643,8.643,0,0,0,8.641-8.644V69.33A8.64,8.64,0,0,0,1.464,60.69H-39.092a8.385,8.385,0,0,0-8.386,8.386v34.911a8.885,8.885,0,0,1-8.885,8.885h0a8.885,8.885,0,0,1-8.885-8.885V49.516a8.645,8.645,0,0,1,8.644-8.644H-37.6a7.705,7.705,0,0,1,5.636,2.455l6.684,7.2H-8.941A8.64,8.64,0,0,1-.3,59.164V60.69",
    transform: "translate(0)",
    fill: "none",
    stroke: "#263757",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5420",
    "data-name": "Line 5420",
    y2: 19.934,
    transform: "translate(-18.728 76.699)",
    fill: "none",
    stroke: "#263757",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5421",
    "data-name": "Line 5421",
    x1: 19.934,
    transform: "translate(-28.695 86.666)",
    fill: "none",
    stroke: "#263757",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/add-folder.3c6cac36775dfc68f3ee4977efd35536.svg";
export { ForwardRef as ReactComponent };